import { toast } from 'sonner';

import { useRefetchDeliveryNoteMutation } from '@/graphql/mutations/refetchDeliveryNote.generated';
import i18n from '@/utils/i18n';

// Admin-only: fetches just the delivery note (Lieferschein) for the given
// order(s) - regenerating it on the fly when missing - and opens the returned
// PDF in a new tab. Unlike useRefetchOrderDocuments this fetches only the
// delivery note (no shipping label), so it works for orders in any status,
// including cancelled ones.
export function useRefetchDeliveryNote() {
  const [refetchDeliveryNote, { loading }] = useRefetchDeliveryNoteMutation();

  const handleRefetchDeliveryNote = async (ids: string[]) => {
    let data: Awaited<ReturnType<typeof refetchDeliveryNote>>['data'];

    try {
      const response = await refetchDeliveryNote({ variables: { ids } });
      data = response.data;
    } catch {
      toast.error(i18n.t('Order:toastDeliveryNoteError'));
      return;
    }

    const result = data?.refetchDeliveryNote;
    if (result?.has_errors || !result?.delivery_note_url) {
      toast.error(i18n.t('Order:toastDeliveryNoteError'));
      return;
    }
    window.open(result.delivery_note_url, '_blank');
    toast.success(i18n.t('Order:toastDeliveryNoteSuccess'));
  };

  return { handleRefetchDeliveryNote, refetchingDeliveryNote: loading };
}
